import { message } from "antd";
import { axiosGet, axiosPatch, axiosPost } from "../axios";

export const getOrdersList = async ({
  orderStatus = ["NOT_REDEEMED"],
  currentPage = 1,
  itemPerPage = 10,
  text,
}) => {
  try {
    const bId = localStorage.getItem("businessId")
    const uId = localStorage.getItem("userId")
    const res = await axiosGet({
      path: `orders/list-vendor-orders?orderStatus=[${`"${orderStatus}"`}]&pageNumber=${currentPage}&itemPerPage=${itemPerPage}&userId=${uId}&businessId=${bId}${text ? `&text=${text}` : ""
        }`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const updateOrder = async (id, payload) => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosPatch({
      path: `orders/${id}?userId=${uId}`,
      payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const addOrder = async (payload) => {
  try {
    const res = await axiosPost({
      path: "orders",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const getOrderDetails = async (id) => {
  try {
    const res = await axiosGet({
      path: `orders/order-detail?orderId=${`${id}`}`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
